module.exports = __webpack_public_path__ + "static/media/doc2.68281324.png";